// extracted by mini-css-extract-plugin
module.exports =  {"reviews":"_33974c2b58--reviews--I5heR"};